import axios from "axios";

export class ApiError extends Error {
  constructor(
    public errorCode: string,
    message: string,
    public statusCode: number,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export const INVALID_IXD_STRUCTURE_ERROR_CODE = "INVALID_IXD_STRUCTURE";

export const DSD_SECTION_NOT_FOUND_ERROR_CODE = "DSD_SECTION_NOT_FOUND_ERROR";

/** 인터셉터가 ApiError 로 감싸기 전(blob 등)일 수도 있어 axios 응답 본문도 함께 본다. */
const hasErrorCode = (error: unknown, errorCode: string): boolean => {
  if (error instanceof ApiError) {
    return error.errorCode === errorCode;
  }
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { error_code?: string } | undefined;
    return data?.error_code === errorCode;
  }
  return false;
};

/** 제출용 IXD 등 편집용 필수 구조가 없는 파일 업로드에 대한 백엔드 응답인지 판별한다. */
export const isInvalidIxdStructureError = (error: unknown): boolean =>
  hasErrorCode(error, INVALID_IXD_STRUCTURE_ERROR_CODE);

/**
 * DSD 에서 "(첨부) 재 무 제 표" 섹션을 찾지 못했다는 백엔드 응답인지 판별한다.
 * 사업·반기·분기보고서 본문 DSD 를 올렸을 때 나는 422 다.
 */
export const isDsdSectionNotFoundError = (error: unknown): boolean =>
  hasErrorCode(error, DSD_SECTION_NOT_FOUND_ERROR_CODE);
